import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import { useFragment } from 'react-relay/hooks'
import { ShipmentLinkCard_data$key } from '../../__generated__/ShipmentLinkCard_data.graphql'
import styled from 'styled-components'
import { Avatar, Typography, Badge as MuiBadge } from '@material-ui/core'
import SemanticString from '../SemanticString'
import Badge from '../Badge'
import SemanticLine from '../SemanticLine'

interface Props {
  data: ShipmentLinkCard_data$key
}

const Root = styled.div`
  text-decoration: unset;
  color: unset;
  border: 1px solid ${(props) => props.theme.customPalette.border.card};
  border-radius: 4px;
  display: flex;
  align-items: center;
  overflow: hidden;

  &:hover {
    border-color: ${(props) => props.theme.palette.primary.main};
  }
`

const Meta = styled.div`
  padding: 8px;
  height: 100%;
  white-space: pre;
`

const TitleContainer = styled.div`
  padding: 8px 8px 8px 0;
  white-space: pre;
  overflow: hidden;
  background-color: ${(props) => props.theme.palette.background.paper};
  flex: 1;
`

const TitleText = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
`

const LinkAvatar = styled(Avatar)`
  width: 40px;
  height: 40px;
`

const BadgeContainer = styled.span`
  background-color: ${(props) => props.theme.palette.background.paper};
  border-radius: 50%;
  padding: 2px;
`

const ShipmentLinkCard: React.FC<Props> = ({ data }) => {
  const link = useFragment(linkFragment, data)
  return (
    <Root>
      <Meta>
        {link.imageUrl && (
          <MuiBadge
            overlap='circle'
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            badgeContent={
              link.badge && (
                <BadgeContainer>
                  <Badge data={link.badge} />
                </BadgeContainer>
              )
            }
          >
            <LinkAvatar alt={link.type || ''} src={link.imageUrl} />
          </MuiBadge>
        )}
      </Meta>
      <TitleContainer>
        {link.title && (
          <TitleText variant='body1'>
            <SemanticString data={link.title} />
          </TitleText>
        )}
        {link.lines?.map((line) => (
          <SemanticLine key={line.key} data={line} />
        ))}
      </TitleContainer>
    </Root>
  )
}

const linkFragment = graphql`
  fragment ShipmentLinkCard_data on Link {
    type
    title {
      ...SemanticString_data
    }
    meta {
      ...SemanticString_data
    }
    badge {
      ...Badge_data
    }
    lines {
      key
      ...SemanticLine_data
    }
    imageUrl
  }
`

export default ShipmentLinkCard
